// extracted by mini-css-extract-plugin
export default {"root":"SitesPage_root__wR9K2","headerContainer":"SitesPage_headerContainer__tLXj+","headerTitle":"SitesPage_headerTitle__NwnHq"};